<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="800px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="traceinfo"
      label-width="110px"
      :rules="rules">
      <el-form-item
        :label="envName + '名称:'"
        prop="envInfoName">
        <el-input v-model.number="traceinfo.envInfoName"></el-input>
      </el-form-item>
      <template v-for="(item, index) in traceinfo.extraFields">
        <smart-form
          :key="index"
          :item="item"
          :vendorId="traceinfo.vendorId"
          :prop="'extraFields.' + index + '.fieldValue'" />
      </template>
      <el-form-item
        :label="envName + '图片:'"
        prop="envImage">
        <upload-image
          v-model="traceinfo.envImage"
          :limit="5" />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadImage from '@/components/public/upload-image-new.vue'
import '@/components/business/custom-form/index'
export default {
  name: 'TraceInfoModal',
  components: { UploadImage },
  props: {
    action: {
      type: String,
      default: 'add'
    },
    fetch: {
      type: Function,
      required: true
    },
    vendorId: [String, Number],
    envInfoType: [String, Number],
    envName: String,
    current: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      traceinfo: {
        envInfoName: '',
        envImage: [],
        extraFields: []
      },
      rules: {
        envInfoName: [{ required: true, message: '请输入信息名称', trigger: 'blur' }],
        envImage: [{ required: true, message: '请上传图片', trigger: 'change' }]
      }
    }
  },
  computed: {
    title() {
      return (this.traceinfo.envInfoId ? '编辑' : '新增') + this.envName
    }
  },
  watch: {
    visible(val) {
      if (val && this.action === 'add') {
        this.gettracingenvinfotemplate()
      }
    },
    current: {
      handler(val) {
        if (val.envInfoId) {
          this.traceinfo = {
            ...this.traceinfo,
            ...val
          }
        }
      },
      deep: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.traceinfo = {
        envInfoName: '',
        envImage: []
      }
    },
    gettracingenvinfotemplate() {
      this.loading = true
      this.$store.dispatch('traceinfo/gettracingenvinfotemplate', {
        payload: {
          vendorId: this.vendorId,
          envInfoType: this.envInfoType
        },
        success: (res) => {
          this.loading = false
          this.traceinfo = {
            ...this.traceinfo,
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.traceinfo.envInfoId) {
            this.updatetracingenvinfo()
          } else {
            this.addtracingenvinfo()
          }
        }
      })
    },
    addtracingenvinfo() {
      this.$store.dispatch('traceinfo/addtracingenvinfo', {
        payload: {
          vendorId: this.vendorId,
          envInfoType: this.envInfoType,
          ...this.traceinfo,
          envImage: this.traceinfo.envImage.map(item => item.url).join(',')
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatetracingenvinfo() {
      this.$store.dispatch('traceinfo/updatetracingenvinfo', {
        payload: {
          ...this.traceinfo,
          envImage: this.traceinfo.envImage.map(item => item.url).join(',')
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
